export const resources = {
  en: {
    translation: {
      nav: {
        howItWorks: "How It Works",
        products: "Products",
        contracts: "Certificates",
        pricing: "Service Provider",
        contact: "Contact Us",
        support: "Support",
        contactUs: "Contact Us",
        troubleshoot: "Trouble with your Tech Certificate",
        verify: "Verify Certificate"
      },
      hero: {
        status: "Live Network Status: Operational",
        heading: {
          instant: "VERIFY.",
          secure: "CERTIFY.",
          anonymous: "DELIVER."
        },
        subtitle: "Enabling technology certificates for secure digital access. one transaction at a time.",
        trustIndicators: {
          security: "Enterprise Security",
          global: "Global Coverage",
          instant: "Real-time Delivery"
        },
        cta: "Get in Touch",
        pricing: "View Pricing"
      },
      poweredBySODL: {
        label: "INFRASTRUCTURE",
        titlePrefix: "Powered by",
        titleMain: "SODL PLATFORM",
        subtitle: "Next-generation global networking architecture designed for international scale.",
        processor: "Glacio PROCESSOR v2.0",
        online: "ONLINE",
        streams: {
          payment: "TRANSMIT",
          verify: "VALIDATE",
          mint: "ENCRYPT",
          settle: "DEPLOY"
        },
        stats: {
          throughput: "Potential Throughput",
          latency: "Latency",
          uptime: "Uptime"
        },
        features: {
          decentralized: {
            title: "Decentralized Network",
            description: "800+ validators worldwide"
          },
          secure: {
            title: "Highly Secure",
            description: "End-to-end encryption"
          },
          fast: {
            title: "Lightning Fast",
            description: "Sub-second processing"
          }
        },
        allSystemsOperational: "All Systems Operational"
      },
      howItWorks: {
        badge: "The Securing Process",
        title: "How It",
        titleHighlight: "Works",
        subtitle: "Engage your customers in processes they are already familiar with while we manage the underline tech.",
        steps: {
          payment: {
            title: "Secure Entry",
            description: "Users connect via Glacio Pro. Our universal entry point manages access requests with multi-layered technology security built-in.",
            highlights: ["Visa & Mastercard", "Apple Pay", "Google Pay", "3DS Security"]
          },
          purchaseCertificate: {
            title: "User purchases technology certificate",
            description: "A technology certificate is tied to a particular service as well as the user initiating the request. When a service provider receives a technology certificate request they automatically, provided the request is securely confirmed by all parties; the technology certificate is validated with access tokens created by the service provider.",
            highlights: ["Tied to Service", "Access Tokens", "Secure Confirmation"]
          },
          guaranteeService: {
            title: "Glacio Pro Securely Guarantees Access",
            description: "A technology certificate is issued giving the user secure access, and proving it. By securely verifying this, Glacio Pro extends its multi-layered technology security from the point of entry through to the final user access.",
            highlights: ["On-chain Confirmation", "Verified Delivery"]
          },
          merchantDelivery: {
            title: "Access Delivered",
            description: "The Glacio Pro Platform guarantees the access recorded on the technology certificate has been provided.",
            highlights: ["On-chain Confirmation", "Verified Delivery"]
          }
        },
        bottomStats: {
          speed: { value: "<4 Seconds", label: "End-to-End" },
          security: { value: "PCI Compliant", label: "Payment Security" },
        }
      },
      pricing: {
        badge: "Service Provider Pricing",
        title: "Your Technology Certificate",
        titleHighlight: "Your Price",
        subtitle: "We work directly with industries to craft pricing that reflects how we verify, certify and deliver for the new age. Security is pivotal in a fast-moving world. Our platform provides a technology tracking code for electronic goods.",
        volumeNote: "Our pricing is based on volume, use case, and integration scope. Reach out and we’ll put together a custom proposal within 24 hours.",
        cta: "Request Pricing Quote",
        bottomNote: "All plans include 99.9% uptime SLA, and dedicated onboarding support.",
        features: {
          volumeBased: "Volume-Based Pricing",
          global: "Verify",
          escrow: "Certify",
          instant: "Deliver",
          dedicated: "Dedicated Account Manager",
          integration: "Custom API Integration"
        }
      },
      products: {
        badge: "Core Products",
        title: "Two Platforms.",
        titleHighlight: "Three Pillars.",
        subtitle: "Verify, Certify, Deliver are the three mandatory pillars required for a technology certificate to be created by Glacio. For secure access to finally be granted, the relevant service provider must authorise the technology certificate using the service provider platform.",
        glacioPro: {
          name: "Glacio Pro Platform",
          subtitle: "Core Execution Layer",
          description: "The Glacio Pro Platform is the central intelligence layer that powers every technology transaction. It orchestrates Verify, Certify, and Deliver in a seamless sequence — establishing verified, certified, and tamper-proof delivery of digital access at the execution layer.",
          tag: "Parent Platform"
        },
        serviceProvider: {
          name: "Glacio Service Provider Platform",
          subtitle: "Extended Partner Layer",
          description: "The Glacio Service Provider Platform extends the core infrastructure to partner organisations, enabling them to operate within the Glacio ecosystem. Built on the same proven execution layer, it provides service providers with the tooling and connectivity required to participate in certified digital commerce.",
          tag: "Partner Platform",
          module: {
            title: "Glacio Pro Service Provider Module",
            subtitle: "Token Engine",
            description: "Glacio Pro operates on a dual party mechanism. Glacio Pro runs and invokes Verify(01), Certify(02), Deliver(03) ; service providers require their own module to be able to leverage the technology required to generate a technology certificate. Each service provider will gain the ability to create their own closed-loop token mechanism without the required technical prowess usually needed to operate such infrastructure.",
            features: ["Closed-Loop Tokens"]
          }
        },
        pillars: {
          pay: {
            title: "Glacio Pro Verify",
            subtitle: "Verification Engine",
            description: "An API request is initiated by the service provider on behalf of end user to access the Glacio service.",
            features: ["SSL", "HTTPS"],
            statValue: "99.9%",
            statLabel: "Uptime"
          },
          mint: {
            title: "Glacio Pro Certify",
            subtitle: "Certification Engine",
            description: "The Glacio platform securely stamps the verification request and authenticates it via our technological solution, issuing the technology certificate that gives the user secure access, and stands as its proof.",
            features: [],
            statValue: "<1s",
            statLabel: "Time Taken"
          },
          settlements: {
            title: "Glacio Pro Deliver",
            subtitle: "Delivery Engine",
            description: "The generated certificate is then combined with an API call and activated through the Glacio platform, delivering the access it certifies.",
            features: ["OAuth", "TLS"],
            statValue: "24/7",
            statLabel: "Settlement"
          }
        }
      },
      blog: {
        badge: "Live AI Updates",
        title: "Latest in",
        titleHighlight: "Artificial Intelligence",
        subtitle: "Stay ahead with the latest breakthroughs, research, and industry news from the world of AI and machine learning.",
        searchPlaceholder: "Search AI news...",
        categories: {
          all: "All News",
          chatgpt: "ChatGPT",
          gemini: "Gemini",
          llm: "LLMs",
          openai: "OpenAI",
          anthropic: "Anthropic",
          agents: "AI Agents",
          research: "Research",
          industry: "Industry"
        },
        refresh: "Refresh",
        featured: "Featured",
        readFullArticle: "Read Full Article",
        read: "Read",
        noResults: {
          title: "No articles found",
          description: "Try adjusting your search or filter criteria"
        },
        newsletter: {
          title: "Stay Informed",
          description: "Get the latest AI news and research insights delivered to your inbox.",
          placeholder: "Enter your email",
          subscribe: "Subscribe"
        }
      },
      smartContracts: {
        badge: "Technology Certificates",
        title: "Verification through",
        titleHighlight: "Certification",
        description: "Every viable industry carries inherent friction within its eco-system. A buyer hedges against fraud, A seller absorbs chargeback & A Platform bears the cost of a dispute. This accumulated risk premium silently inflates the cost of doing business for every one involved.This is not a flaw in the system but in fact the entire system we all suffer from but also crave. The question has never been whether risk exists, but who will in fact pay for it and what will that bottom line cost be. Glacio's secure technology certificate challenges the norm we all suffer from. By establishing verified, certified and tamper-proof delivery at the execution layer. We remove the ambiguity that risk feeds on. Fraud cannot exploit what it cannot manipulate; risk becomes a distant memory when provenance is immutable. Our infrastructure is not merely a security feature. It is a logical cost reduction for any eco-system that harnesses the power of digital commerce. We live in a world where digital executions are no longer exceptional they are foundational. Glacio's offering is not solving for an edge case. It is solving for the operating environment we all crave and feed off in society.",
        descriptionTagline: "We provide tracking codes for the digital age.",
        images: {
          first: {
            caption: "A tracking number offers a reliable proof of delivery solution for physical goods. Once a novel concept, it has now become a worldwide standard."
          },
          second: {
            caption: "With the growth of the digital economy our system provides seamless support to certify the veracity of access transactions between participating parties. Each technology certificate gives the user secure access and stands as the proof of it. Our certification solution guarantees proof that access was delivered for both parties, ensuring that what was promised corresponds exactly to what was delivered."
          }
        },
        benefits: {
          instant: {
            title: "Instant Settlement",
            description: "Sub-30 second end-to-end processing."
          },
          compliance: {
            title: "Enterprise Security",
            description: "PCI DSS compliant with multi-layer authentication."
          },
          dispute: {
            title: "Blockchain Native",
            description: "Solana integration for instant token* minting."
          },
          regulatory: {
            title: "Deterministic Finality",
            description: "Instant, irreversible settlement with immediate cryptographic verification."
          },
          multiCurrency: {
            title: "Multi-Currency Support",
            description: "Execute transactions in any supported currency pair."
          }
        }
      },
      contact: {
        badge: "Contact Us",
        title: "Get in",
        titleHighlight: "Touch",
        description: "Have questions about Glacio Pro? We'd love to hear from you. Send us a message and we'll respond as soon as possible.",
        form: {
          firstName: "First Name",
          lastName: "Last Name",
          emailAddress: "Email Address",
          subject: "Subject",
          selectTopic: "Select a topic",
          topics: {
            general: "General Inquiry",
            api: "API Integration",
            enterprise: "Enterprise Solutions",
            partnership: "Partnership",
            support: "Technical Support",
            pricing: "Pricing"
          },
          message: "Message",
          messagePlaceholder: "Tell us how we can help you...",
          submit: "Send Message",
          sending: "Sending…"
        },
        success: {
          title: "Message Sent!",
          description: "Thanks for reaching out. We'll get back to you shortly.",
          sendAnother: "Send another message"
        }
      },
      troubleshoot: {
        badge: "Troubleshoot",
        title: "Trouble with your",
        titleHighlight: "Tech Certificate",
        description: "Having trouble with your Technology Certificate?",
        descriptionSub: "Please contact us here with your details.",
        form: {
          firstName: "First Name",
          lastName: "Last Name",
          emailAddress: "Email Address",
          subject: "Subject",
          selectTopic: "Select a topic",
          topics: {
            certificate: "Certificate Issue",
            access: "Access Problem",
            technical: "Technical Error",
            other: "Other"
          },
          message: "Message",
          messagePlaceholder: "Describe the issue with your tech certificate...",
          submit: "Send Message",
          errors: {
            firstNameRequired: "First name is required.",
            lastNameRequired: "Last name is required.",
            emailRequired: "Email address is required.",
            emailInvalid: "Please enter a valid email address.",
            messageTooShort: "Message must be at least {{min}} characters ({{current}} entered)."
          }
        },
        success: {
          title: "Message Sent!",
          body: "Thanks for reaching out. We'll look into your certificate issue and get back to you shortly.",
          another: "Send another message"
        }
      },
      footer: {
        description: "",
        columns: {
          product: "Service",
          legal: "Legal",
          support: "Support"
        },
        links: {
          smartContracts: "Certificates",
          features: "Products",
          blog: "Blogs",
          contactUs: "Contact Us",
          troubleshoot: "Trouble with your Tech Certificate",
          privacyPolicy: "Privacy Policy",
          terms: "Terms & Conditions",
          cookies: "Cookies Policy",
        },
        rights: "Registered in Cyprus, EU. All rights reserved."
      }
    }
  },
  no: {
    translation: {
      nav: {
        howItWorks: "Slik fungerer det",
        products: "Produkter",
        contracts: "Kontrakter",
        pricing: "Tjenesteleverandør",
        contact: "Kontakt oss",
        support: "Støtte",
        contactUs: "Kontakt oss",
        troubleshoot: "Problem med teknologisertifikatet ditt",
        verify: "Bekreft sertifikat"
      },
      hero: {
        status: "Live nettverksstatus: Operativ",
        heading: {
          instant: "BETAL.",
          secure: "SIKKER.",
          anonymous: "OPPGJØR."
        },
        subtitle: "Aksepterer globale betalinger ved å utnytte blokkjedeteknologi",
        trustIndicators: {
          security: "Bedriftssikkerhet",
          global: "Global dekning",
          instant: "Øyeblikkelig oppgjør"
        },
        cta: "Ta kontakt",
        pricing: "Se priser"
      },
      poweredBySODL: {
        label: "INFRASTRUKTUR",
        titlePrefix: "Drevet av",
        titleMain: "SODL",
        subtitle: "Neste generasjons blokkjedeinfrastruktur-teknologi for global rekkevidde. Denne prosessen styres av SODL, en kypriotisk enhet som sikrer etterlevelse av europeiske og globale reguleringer, inkludert MiCA, DORA, NIS2 m.fl.",
        processor: "SODL-PROSESSOR v2.0",
        online: "TILKOBLET",
        streams: {
          payment: "BETALING",
          verify: "VERIFISER",
          mint: "SIKKER",
          settle: "OPPGJØR"
        },
        stats: {
          throughput: "Potensiell gjennomstrømning",
          latency: "Ventetid",
          uptime: "Oppetid"
        },
        features: {
          decentralized: {
            title: "Desentralisert nettverk",
            description: "800+ validatorer over hele verden"
          },
          secure: {
            title: "Høy sikkerhet",
            description: "Ende-til-ende-kryptering"
          },
          fast: {
            title: "Lynrask",
            description: "Under ett sekunds endeliggjøring"
          }
        },
        allSystemsOperational: "Alle systemer operative"
      },
      howItWorks: {
        badge: "Sikringsprosessen",
        title: "Slik",
        titleHighlight: "fungerer det",
        subtitle: "Fra kortbetaling til on-chain verifisering i tre sømløse trinn. Ingen kryptokunnskap kreves fra kundene dine. SODL-tjenesten muliggjør en tillitsløs transaksjon for digitale varer mellom en kjøper og selger som ikke kjenner eller stoler på hverandre.",
        steps: {
          payment: {
            title: "Kunden betaler",
            description: "Kunden kjøper via Glacio Pay. Vår universelle smarte modal håndterer kortbetalinger med innebygd 3DS-sikkerhet.",
            highlights: ["Visa og Mastercard", "Apple Pay", "Google Pay", "3DS-sikkerhet"]
          },
          purchaseCertificate: {
            title: "Brukeren kjøper teknologisertifikat",
            description: "Et teknologisertifikat er knyttet til en bestemt tjeneste samt brukeren som initierer forespørselen. Når en tjenesteleverandør mottar en forespørsel om teknologisertifikat, bekreftes det automatisk, forutsatt at forespørselen er sikkert bekreftet av alle parter; teknologisertifikatet valideres med tilgangstokener opprettet av tjenesteleverandøren.",
            highlights: ["Knyttet til tjeneste", "Tilgangstokener", "Sikker bekreftelse"]
          },
          guaranteeService: {
            title: "Glacio garanterer tjenesten sikkert",
            description: "Glacio garanterer tjenesten sikkert.",
            highlights: ["On-chain bekreftelse", "Verifisert levering"]
          },
          merchantDelivery: {
            title: "Selger leverer tjeneste",
            description: "Glacio-plattformen bekrefter at den digitale tjenesten er levert.",
            highlights: ["On-chain bekreftelse", "Verifisert levering"]
          }
        },
        bottomStats: {
          speed: { value: "<4 sekunder", label: "Ende-til-ende" },
          security: { value: "PCI-kompatibel", label: "Betalingssikkerhet" }
        }
      },
      pricing: {
        badge: "Bedriftsprising",
        title: "Tilpasset prising for",
        titleHighlight: "din skala",
        subtitle: "Vi samarbeider direkte med selgere for å lage priser som gjenspeiler transaksjonsvolumet, bransjen og integrasjonsbehovene dine. Ingen faste nivåer — bare riktig tilpasning.",
        volumeNote: "Prisene våre er basert på volum, brukstilfelle og integrasjonsomfang. Ta kontakt, så setter vi sammen et tilpasset tilbud innen 24 timer.",
        cta: "Be om pristilbud",
        bottomNote: "Alle planer inkluderer PCI DSS-etterlevelse, 99,9 % oppetid SLA og dedikert onboarding-støtte.",
        features: {
          volumeBased: "Volumbasert prising",
          global: "Global dekning",
          escrow: "Escrow og smartkontrakter",
          instant: "Umiddelbart oppgjør",
          dedicated: "Dedikert kundekontakt",
          integration: "Tilpasset API-integrasjon"
        }
      },
      products: {
        badge: "Kjerneprodukter",
        title: "Én plattform.",
        titleHighlight: "Tre pilarer.",
        subtitle: "Aksepter globale betalinger og verifiseringstokens automatisk i én flyt. Bygget for skapere, designet for skalering.",
        glacioPro: {
          name: "Glacio Pro Platform",
          subtitle: "Kjerneutføringslag",
          description: "Glacio Pro-plattformen er det sentrale intelligenslaget som driver hver teknologitransaksjon. Den orkestrerer Verify, Certify og Deliver i en sømløs sekvens.",
          tag: "Overordnet plattform"
        },
        serviceProvider: {
          name: "Glacio Service Provider Platform",
          subtitle: "Utvidet partnerlag",
          description: "Glacio Service Provider-plattformen utvider kjerneinfrastrukturen til partnerorganisasjoner, slik at de kan operere innenfor Glacio-økosystemet.",
          tag: "Partnerplattform",
          module: {
            title: "Glacio Pro Service Provider Module",
            subtitle: "Token Engine",
            description: "Glacio Pro opererer på en todelt mekanisme. Glacio Pro kjører og aktiverer Verify(01), Certify(02), Deliver(03); tjenesteleverandører trenger sin egen modul for å utnytte teknologien som kreves for å generere et teknologisertifikat. Hver tjenesteleverandør vil få muligheten til å opprette sin egen lukkede token-mekanisme uten den tekniske kompetansen som vanligvis er nødvendig for å drive slik infrastruktur.",
            features: ["Lukkede tokens", "Todelt mekanisme", "Uten kode", "Sertifikat-API"]
          }
        },
        pillars: {
          pay: {
            title: "Glacio Pay",
            subtitle: "Porten",
            description: "Den universelle porten for kort og banker. Legg inn vår ferdigbygde modal for å akseptere Visa, Mastercard, Apple Pay og GPay umiddelbart. Den håndterer 3DS-sikkerhet.",
            features: ["Visa og Mastercard", "Apple Pay og Google Pay", "3DS-sikkerhet"],
            statValue: "99,9%",
            statLabel: "Oppetid"
          },
          mint: {
            title: "Glacio Secure",
            subtitle: "Motoren",
            description: "Motoren som kryptografisk verifiserer transaksjoner. Gjør hver betaling til en uforanderlig post på kjeden. Våre smartkontrakter utløses umiddelbart ved betaling og leverer sikre verifiseringstokens direkte til kundens lommebok.",
            features: ["Automatisert sikkerhet", "Smartkontrakter", "Verifiseringstokens", "Automatisk overføring"],
            statValue: "<1s",
            statLabel: "Pregetid"
          },
          settlements: {
            title: "Glacio Dashboards",
            subtitle: "The Pipeline",
            description: "Monitor your operations with complete transparency. Track real-time transaction statuses and view immutable smart contract execution logs in one place. Export reports from an intuitive interface.",
            features: ["Real-time Analytics", "Smart Contract Monitoring", "Reporting"],
            statValue: "24/7",
            statLabel: "Oppgjør"
          }
        }
      },
      blog: {
        badge: "Live AI-oppdateringer",
        title: "Siste innen",
        titleHighlight: "Kunstig intelligens",
        subtitle: "Hold deg oppdatert med de siste gjennombruddene, forskningen og bransjenyhetene fra verden av AI og maskinlæring.",
        searchPlaceholder: "Søk i AI-nyheter...",
        categories: {
          all: "Alle nyheter",
          chatgpt: "ChatGPT",
          gemini: "Gemini",
          llm: "LLM-er",
          openai: "OpenAI",
          anthropic: "Anthropic",
          agents: "AI-agenter",
          research: "Forskning",
          industry: "Bransje"
        },
        refresh: "Oppdater",
        featured: "Fremhevet",
        readFullArticle: "Les hele artikkelen",
        read: "Les",
        noResults: {
          title: "Ingen artikler funnet",
          description: "Prøv å justere søket eller filterkriteriene"
        },
        newsletter: {
          title: "Hold deg informert",
          description: "Få de siste AI-nyhetene og forskningsinnsiktene levert til innboksen din.",
          placeholder: "Skriv inn e-postadressen din",
          subscribe: "Abonner"
        }
      },
      smartContracts: {
        badge: "Teknologisertifikater",
        title: "Verifisering gjennom",
        titleHighlight: "Sertifisering",
        description: "Vi tilbyr tekniske tjenester for å verifisere transaksjoner og sertifisere deres riktighet. Ingen forsinkelser — bare robust og integrert bevis på levering.",
        descriptionTagline: "Vi leverer sporingskoder for den digitale tidsalderen.",
        images: {
          first: {
            caption: "Et sporingsnummer gir en pålitelig bekreftelse på levering for fysiske varer. En gang et nytt konsept, er det nå blitt en verdensomspennende standard."
          },
          second: {
            caption: "Med veksten i den globale økonomien gir systemet vårt sømløs støtte for å sertifisere riktigheten av transaksjoner mellom deltakende parter. Vår sertifiseringsløsning garanterer bevis på levering for begge parter, og sikrer at det som ble lovet tilsvarer nøyaktig det som ble levert."
          }
        },
        benefits: {
          instant: {
            title: "Øyeblikkelig oppgjør",
            description: "Under 30 sekunders ende-til-ende-behandling."
          },
          compliance: {
            title: "Bedriftssikkerhet",
            description: "PCI DSS-kompatibel med flerlagsautentisering."
          },
          dispute: {
            title: "Blokkjedenativ",
            description: "Solana-integrasjon for umiddelbar tokenpreging."
          },
          regulatory: {
            title: "Deterministisk endeliggjøring",
            description: "Øyeblikkelig, irreversibelt oppgjør med umiddelbar kryptografisk verifisering."
          },
          multiCurrency: {
            title: "Støtte for flere valutaer",
            description: "Utfør transaksjoner i ethvert støttet valutapar."
          }
        }
      },
      contact: {
        badge: "Kontakt oss",
        title: "Ta",
        titleHighlight: "kontakt",
        description: "Har du spørsmål om Glacio? Vi vil gjerne høre fra deg. Send oss en melding, så svarer vi så snart som mulig.",
        form: {
          firstName: "Fornavn",
          lastName: "Etternavn",
          emailAddress: "E-postadresse",
          subject: "Emne",
          selectTopic: "Velg et emne",
          topics: {
            general: "Generell henvendelse",
            api: "API-integrasjon",
            enterprise: "Bedriftsløsninger",
            partnership: "Partnerskap",
            support: "Teknisk støtte",
            pricing: "Prising"
          },
          message: "Melding",
          messagePlaceholder: "Fortell oss hvordan vi kan hjelpe deg...",
          submit: "Send melding"
        },
        success: {
          title: "Melding sendt!",
          description: "Takk for at du tok kontakt. Vi svarer deg så snart som mulig.",
          sendAnother: "Send en ny melding"
        }
      },
      troubleshoot: {
        badge: "Feilsøking",
        title: "Problem med",
        titleHighlight: "teknologisertifikatet ditt",
        description: "Har du problemer med teknologisertifikatet ditt? Gi oss beskjed, så hjelper vi deg så raskt som mulig.",
        form: {
          firstName: "Fornavn",
          lastName: "Etternavn",
          emailAddress: "E-postadresse",
          subject: "Emne",
          selectTopic: "Velg et emne",
          topics: {
            certificate: "Sertifikatproblem",
            access: "Tilgangsproblem",
            technical: "Teknisk feil",
            other: "Annet"
          },
          message: "Melding",
          messagePlaceholder: "Beskriv problemet med teknologisertifikatet ditt...",
          submit: "Send melding",
          errors: {
            firstNameRequired: "Fornavn er påkrevd.",
            lastNameRequired: "Etternavn er påkrevd.",
            emailRequired: "E-postadresse er påkrevd.",
            emailInvalid: "Vennligst oppgi en gyldig e-postadresse.",
            messageTooShort: "Meldingen må være minst {{min}} tegn ({{current}} skrevet inn)."
          }
        },
        success: {
          title: "Melding sendt!",
          body: "Takk for at du tok kontakt. Vi ser på sertifikatproblemet ditt og kommer tilbake til deg snart.",
          another: "Send en ny melding"
        }
      },
      footer: {
        description: "Neste generasjons protokoll for sømløse grenseoverskridende transaksjoner. Bygget for utviklere, designet for skalering.",
        columns: {
          product: "Tjeneste",
          legal: "Juridisk",
          support: "Støtte"
        },
        links: {
          smartContracts: "Smarte kontrakter",
          features: "Produkter",
          blog: "Blogger",
          contactUs: "Kontakt oss",
          troubleshoot: "Problem med teknologisertifikatet ditt",
          privacyPolicy: "Personvernregler",
          terms: "Vilkår og betingelser",
          cookies: "Retningslinjer for informasjonskapsler",
        },
        rights: "Alle rettigheter reservert."
      }
    }
  }
};
